<template>
  <div
    class="tab-pane fade"
    id="rekening"
    role="tabpanel"
    aria-labelledby="rekening-tab"
  >
    <div class="card" style="" id="rekeningCard">
      <div class="card-body mt-4 text-center">
        <div class="card-group text-left">
          <div
            v-for="(acc, index) in user.account"
            :key="index"
            class="card"
            style="box-shadow: none"
          >
            <div class="card-body">
              <form>
                <div class="mb-3">
                  <div id="" class="form-text">
                    REKENING BANK {{ index + 1 }}
                  </div>
                  <label for="" class="form-label">Nama Bank :</label>
                  <input
                    :disabled="disabledEdit"
                    type="text"
                    class="form-control"
                    :id="'bankName' + (index + 1)"
                    aria-describedby=""
                    :value="acc.bank"
                  />
                </div>
                <div class="mb-3">
                  <label for="" class="form-label">Nomor Rekening :</label>
                  <input
                    :disabled="disabledEdit"
                    type="text"
                    class="form-control"
                    :id="'number' + (index + 1)"
                    :value="acc.number"
                  />
                </div>
                <div class="mb-3">
                  <label for="" class="form-label">Atas Nama :</label>
                  <input
                    :disabled="disabledEdit"
                    type="text"
                    class="form-control"
                    :id="'asName' + (index + 1)"
                    :value="acc.asName"
                  />
                </div>
                <button
                  type="button"
                  :disabled="disabledEdit"
                  class="btn btn-primary"
                  @click="editRekening(index + 1, acc.id)"
                  id="updateNorek"
                >
                  Update
                </button>
                <p v-if="disabledEdit" class="text-muted font-italic">
                  Untuk mengganti Akun Bank mohon hubungi CS EUREKA
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import $ from "jquery";
export default {
  data() {
    return {
      disabledEdit: true,
    };
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },
  methods: {
    editRekening(index, bankId) {
      if (this.disabledEdit) {
        this.$toast.warning(
          "Untuk mengganti Akun Bank mohon hubungi CS EUREKA"
        );
      } else {
        //   console.log(index)
        var formdata = new FormData();
        var myHeaders = new Headers();

        myHeaders.append(
          "Cookie",
          "ci_session=k4piijumodoaunrs46rav4fato0sln1v"
        );

        formdata.append("mall_id", this.user.id);
        formdata.append("ids_rek", bankId);
        formdata.append("nama_bank", $(`#bankName${index}`).val());
        formdata.append("nomor_rekening", $(`#number${index}`).val());
        formdata.append("atas_nama", $(`#asName${index}`).val());
        formdata.append("param", "rek_mall");

        var requestOptions = {
          method: "PUT",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };

        let gThis = this;

        this.$swal
          .fire({
            title: "Anda yakin?",
            text: "Anda yakin ingin mengubah Rekening Bank?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
          })
          .then((result) => {
            if (result.isConfirmed) {
              fetch(
                "https://siplah.eurekabookhouse.co.id/staging/backendseller/konfigurasi_api",
                requestOptions
              )
                .then((response) => {
                  this.$store.dispatch("get_user");
                  return response;
                })
                .then(() => {
                  gThis.$swal.fire(
                    "Berhasil!",
                    "Anda berhasil mengupdate profile anda",
                    "success"
                  );
                });
            }
          });
      }
    },
  },
};
</script>
